var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentUser.id && _vm.isReady)?_c('div',[(!_vm.canUseMultipleSessions)?_c('ReportPageV2'):_c('div',[(_vm.isRenderedReport)?_c('ReportPageV2',{key:_vm.selectedSession?.presentationId || 'no-session'}):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }